<template>
  <div>
    <div class="tour">
      <iframe width="100%" height="100%" :src="tourUrl" frameborder="0" allowfullscreen></iframe>
    </div>
    <router-link to="/tourscene">
      <button>
        <svg fill="#fff" height="1rem" width="1rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
          <polygon points="256,8.533 0,247.467 0,281.6 68.267,281.6 68.267,503.467 187.733,503.467 187.733,366.933 324.267,366.933 
			324.267,503.467 443.733,503.467 443.733,281.6 512,281.6 512,247.467 		" />
        </svg>返回主界面</button>
    </router-link>
  </div>
</template>

<script>
export default {
  computed: {
    tourUrl() {
      // 使用 process.env.BASE_URL 或其他方式获取基本路径
      const baseUrl = process.env.BASE_URL || '/';
      return `${baseUrl}vtour_cawsmart/tour.html?startscene=0&startlookat=0,0,90,0,0;`;
    },
  },
};
</script>

<style scoped>
.tour {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

button {
  position: absolute;
  font-size: 1REM;
  font-family: 'Source Han Sans-Medium';
  color: #fff;
  border: 2px solid #fff;
  border-radius: 5px;
  background-color: rgba(128, 128, 128, 0.6);
  padding: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
}

button:hover {
  background-color: rgba(32, 32, 32, 0.6);
}

svg {
  position: relative;
  transform: translateY(-16%);
  margin-right: 0.25rem;
}
</style>